<template>
    <td-dialog :title="$t(title)" :before-close="logReLevelDialogClose" :visible.sync="dialogReLevelVisible" width="550px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formLevelInfo" :inline="true" :label-width="formLabelWidth" ref="formLevelInfo" :rules="rules">
            <el-form-item>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <td-table
                            class="table_margin paddingTop20"
                            :columns="columns"
                            :dataSource="tableData"
                            :hasMutiSelect="hasMutiSelect"
                            :hasPage="hasPage"
                            height="200px"
                            ref="listTypeInfo"
                            :rowKey="rowKey"
                        ></td-table>
                    </el-col>
                    <el-col :span="12">
                        <td-tree
                            :checkNodes="checkNodes"
                            :inputShow="inputShow"
                            :isSingleCheck="isSingleCheck"
                            :calInternal="calInternal"
                            :height="height"
                            :treeList="treeList"
                            :lazyloading="lazyloading"
                            :showBox="showBox"
                            ref="treeData"
                        >
                        </td-tree>
                    </el-col>
                </el-row>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formLevelInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="logReLevelDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import typeApi from '../assets/api.js';
import levelApi from '../../logLevelManager/assets/api.js';
export default {
    props: ['title', 'dialogReLevelVisible', 'items', 'sSysFlg'],
    created() {
        let param = {
            sSysFlg: this.sSysFlg,
            isPage: false
        };
        levelApi.queryOperationLevel(JSON.stringify(param), response => {
            if (response.status !== this.$common.login.RESPONSE_STATUS) {
                this.$log.error('logTypeManager/queryOperationLevel', response);
                return;
            }
            if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('logTypeManager/queryOperationLevel', response.data.statusMessage);
                return;
            }
            let levelList = response.data.content;
            this.treeList = [];
            if (levelList) {
                for (let i = 0; i < levelList.length; i++) {
                    let temValue = levelList[i];
                    let item = {
                        id: temValue.sId,
                        label: temValue.sCaption
                    };
                    this.treeList.push(item);
                }
            }
        });
        this.tableData = this.items;
    },
    // 定义变量
    data() {
        return {
            // 表单信息
            formLevelInfo: {},
            formLabelWidth: '100px',
            lazyloading: false,
            treeList: [],
            inputShow: false,
            calInternal: false,
            height: 200,
            showBox: true,
            hasMutiSelect: false,
            hasPage: false,
            tableData: [],
            isSingleCheck: true,
            columns: [
                {
                    prop: 'sCaption',
                    label: 'common.NAME'
                }
            ]
        };
    },
    // 定义并实现方法体
    methods: {
        // 提交数据
        submitForm() {
            let _this = this;
            let checkedNodes = _this.$refs.treeData.getCheckedNodes();
            let content = [];
            if (_this.items && checkedNodes && checkedNodes.length) {
                for (let i = 0; i < _this.items.length; i++) {
                    let temValue = _this.items[i];
                    let select = {
                        sId: temValue.sId,
                        sCaption: temValue.sCaption,
                        sDescribe: temValue.sDescription,
                        sPermission: temValue.sPermission,
                        sOperationLevelId: checkedNodes[0].id
                    };
                    content.push(select);
                }
                typeApi.updateOperationTypeBatch(JSON.stringify(content), response => {
                    if (response.data.statusCode !== _this.$common.requestCode.SUCCESS_INFO_CODE) {
                        _this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        _this.$log.error('dialogReLevelInfo/updateOperationTypeBatch', response);
                        return;
                    }
                    _this.$message({ showClose: true, message: _this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                    _this.logReLevelDialogSave();
                });
            } else {
                _this.logReLevelDialogSave();
            }
        },
        // 关闭窗口之前需要调用的方法
        logReLevelDialogClose() {
            this.$emit('logReLevelDialogClose');
        },
        // 添加或者修改关闭窗口之前需要调用的方法
        logReLevelDialogSave() {
            this.$emit('logReLevelDialogClose');
            this.$emit('submit');
            this.$refs['formLevelInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style scoped>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.table_margin {
    margin-top: -20px;
}
</style>
